import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { MapState } from './types'
import { RootState } from '../types'

export const state: MapState = {
  markers: {},
  things: {},
  entitiesFiltered: {},
  map: {},
  payloadIsEmpty: false,
  thingsToFollow: [],
  pondRippleEvent: null,
  streetViewPanoramaElement: null,
  isPanoramActive: false,
  drawerComponent: '',
}

const namespaced = true

export const mapState: Module<MapState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
